import { render } from "./GestionPilares.vue?vue&type=template&id=5d5f26d0"
import script from "./GestionPilares.vue?vue&type=script&lang=js"
export * from "./GestionPilares.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__